export const FETCH_NOTICE_TYPE = "noticeType/fetch";
export const DELETE_NOTICE_TYPE = "noticeType/delete";
export const ADD_NOTICE_TYPE = "noticeType/add";
export const UPDATE_NOTICE_TYPE = "noticeType/update";
